import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const StackIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path opacity="0.2" d="M4 10L16 17L28 10L16 3L4 10Z" fill="#2E2E2E" />
      <path
        d="M4 22L16 29L28 22"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 16L16 23L28 16"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 10L16 17L28 10L16 3L4 10Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default StackIcon;
